"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    HotelPricePin: ()=>HotelPricePin
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
require("react");
const getPriceUtils_js_namespaceObject = require("../../HotelComponent/HotelListingCard/components/Price/getPriceUtils.js");
const HotelPricePin = (props)=>{
    const totalPrice = (0, getPriceUtils_js_namespaceObject.getTotalPrice)({
        totalPrice: props?.hotel?.ratesSummary?.grandTotal,
        priceDisplayRegulation: props?.hotel?.ratesSummary?.priceDisplayRegulation,
        grandTotalExcludingTax: props?.hotel?.ratesSummary?.grandTotalExcludingTax
    });
    const grandTotal = Number(totalPrice);
    const currency = props?.hotel?.ratesSummary?.minCurrencyCodeSymbol || '$';
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)("div", {
        className: "relative",
        children: [
            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
                className: "bg-primary-8 border-primary-1 rounded-full border px-2 py-1",
                children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)("span", {
                    className: "text-priceRetail-1 font-bold",
                    children: [
                        currency,
                        Math.floor(grandTotal)
                    ]
                })
            }),
            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
                className: "bg-primary-8 border-primary-1 absolute bottom-0 left-1/2 h-2 w-2 -translate-x-1/2 translate-y-[3.5px] rotate-45 border-b border-r"
            })
        ]
    });
};
exports.HotelPricePin = __webpack_exports__.HotelPricePin;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "HotelPricePin"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
